export function simulationFilterInfo(state = {}, { filter = {}, type }) {
    switch (type) {
        case 'GET_SIMULATION_FILTER':
            return {}
        case 'UPDATE_SIMULATION_FILTER':
            return { ...state, ...filter }
        case 'CLEAR_SIMULATION_FILTER':
            return filter
        default:
            return state
    }
}
